import React, {FC} from "react";
import {useAxios} from "../../../utils/hooks";
import useSafeState from "../../../utils/safe-state";
import {Trans} from "@lingui/macro";
import {Breadcrumb, Button, Divider, message, Popconfirm, Tooltip} from "antd";
import {
    DeleteTwoTone,
    PlusOutlined,
    UploadOutlined
} from "@ant-design/icons/lib";
import DtoTable from "../../../components/dto-table/dto-table";
import ButtonWithIcon from "../../../components/buttons/button-with-icon";
import SupplierModel from "../../../models/suppliers/supplier-model";
import {EditOutlined} from "@ant-design/icons";
import Drawer from "../../../components/drawer/drawer";
import SupplierDrawer from "../../../forms/supplier-form";
import {openNotification} from "../../../utils/openNotification";

const SuppliersScreen: FC = () => {

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [trigger, setTrigger] = useSafeState(false);
    const supplierText = <Trans>Supplier</Trans>

    const supplierDrawer = Drawer(
        {
            title: supplierText,
            children:
                <SupplierDrawer/>,
            customClose: () => setTrigger(function(prev) { return !prev; })
        }
    );

    const handleDelete = (record: any) => {

        if (axiosInstance.current != null) {
            axiosInstance.current
                .delete('/resource/suppliers/id?id=' + encodeURIComponent(record.code)
                )
                .then(() => {
                    openNotification('customSuccess', 'Deleted')
                    setTrigger(function(prev) { return !prev; });
                })
                .catch(function (error: any) {
                    openNotification('error', error);
                    setTrigger(function(prev) { return !prev; });
                });
        }
    };

    const action = (record: any) => {

        return (
            <>
                <Tooltip title={<Trans>Edit</Trans>}>
                    <EditOutlined className={"ActionButtons"} style={{color: "#40a9ff"}}
                                  onClick={() =>
                                      supplierDrawer
                                      .open(
                                          "Edit",
                                          {
                                                code: record.code,
                                                name: record.name,
                                                isEu: record.isEu,
                                                version: record.version
                                          })
                                  }
                    />
                </Tooltip>
                <Tooltip title={<Trans>Remove</Trans>}>
                    <Popconfirm
                        title={<Trans>Are you sure want to delete record?</Trans>}
                        onConfirm={() => handleDelete(record)}
                        okText={<Trans>Yes</Trans>}
                        cancelText={<Trans>No</Trans>}>
                        <DeleteTwoTone className={"ActionButtons"} twoToneColor={"red"}/>
                    </Popconfirm>

                </Tooltip>

            </>
        )
    };

    const actions = {
        width: 80,
        render: (text: string, record: any) => action(record),
        title: '',
        fixed: 'right',
        align: 'center'
    };

    const header = (
        <>
            <Button type={'primary'} onClick={() => supplierDrawer.open('Add new')} style={{ float: 'left' }}>
                <ButtonWithIcon icon={<PlusOutlined />} text={<Trans>Add new</Trans>} />
            </Button>
            <Divider type="vertical" style={{ float: 'left', fontSize: 'xxx-large' }} />
        </>
    );


    return (<>

            <>

                <Breadcrumb style={{marginBottom: 10}}>
                    <Breadcrumb.Item><Trans id={'Home'}/></Breadcrumb.Item>
                    <Breadcrumb.Item><Trans>Data Maintenance</Trans></Breadcrumb.Item>
                    <Breadcrumb.Item><Trans id={'Suppliers'}></Trans></Breadcrumb.Item>
                </Breadcrumb>
                <DtoTable
                    tableHeader={header}
                    model={SupplierModel}
                    action={actions}
                    trigger={trigger}
                    allowRefreshButton={true}
                    allowExport={true}
                    pageSize={100}
                    scroll={{x: 1300, y: "65vh"}}/>
            </>
            {supplierDrawer.component}
        </>
    )
}
export default SuppliersScreen;
